export default __webpack_public_path__ + "static/media/jamstackArchitecture.47b14772.md";